import { render, staticRenderFns } from "./GoalPage.vue?vue&type=template&id=9346aa04&scoped=true"
import script from "./GoalPage.vue?vue&type=script&lang=js"
export * from "./GoalPage.vue?vue&type=script&lang=js"
import style0 from "./GoalPage.vue?vue&type=style&index=0&id=9346aa04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9346aa04",
  null
  
)

export default component.exports